export const createHTML = <K extends keyof HTMLElementTagNameMap>(
  tagName: K | string,
  attrs: Partial<HTMLElementTagNameMap[K]> = {},
  children: Node[] = [],
) => {
  const baseElement = document.createElement(tagName);
  children.forEach((child) => baseElement.appendChild(child));
  Object.entries(attrs).forEach(([attr, value]) => baseElement.setAttribute(attr, value));
  return baseElement;
};
